import inboxSettingsMap from "../../shared/inbox-settings.json";

export function decodeInboxSettings(code) {
    return inboxSettingsMap[code] || null;
}

export function encodeInboxSettings(settings) {
    for (const [code, vals] of Object.entries(inboxSettingsMap)) {
        if (
            vals.crmMode == settings.crmMode &&
            vals.unreadOnly == settings.unreadOnly &&
            vals.draftsOnly == settings.draftsOnly &&
            vals.threadTexts == settings.threadTexts
        ) {
            return code;
        }
    }
    return null;
}
